// Branding white label: judul (tab & login), logo (login & sidebar), favicon, "powered by" (login & footer).
// Halaman login mengenali perusahaan dari domain tempat aplikasi dibuka; setelah login dipakai perusahaan user.
// Dibaca lewat endpoint publik (tanpa token); gambar disajikan dari database lewat publik/branding_gambar.
import { reactive } from 'vue'
import axios from 'axios'
import appConfig from '@/utils/pengaturan'
import logoBawaan from '@/assets/images/wina.png'

export const branding = reactive({ judul: 'WINA', logoPath: '', faviconPath: '', poweredBy: 'PT PPI (Persero)', poweredUrl: '', idPerusahaan: null })

function apiUrl() {
  return localStorage.getItem('url') || appConfig.apiUrl
}

// Path dari server relatif ke index.php (mis. "publik/branding_gambar?p=3&j=logo&v=2")
function urlGambar(path) {
  return apiUrl() + path
}

// Ganti semua ikon tab/layar beranda (index.html punya banyak ukuran); href asli disimpan agar bisa dipulihkan
function terapkanFavicon() {
  document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]').forEach((el) => {
    if (!el.dataset.asli) el.dataset.asli = el.getAttribute('href')
    el.setAttribute('href', branding.faviconPath ? urlGambar(branding.faviconPath) : el.dataset.asli)
    if (branding.faviconPath) el.setAttribute('type', 'image/png')
  })
}

export function faviconUrl() {
  return branding.faviconPath ? urlGambar(branding.faviconPath) : '/favicon-96x96.png'
}

// URL logo aktif; logo bawaan aplikasi bila belum diganti
export function logoUrl() {
  return branding.logoPath ? urlGambar(branding.logoPath) : logoBawaan
}

export function terapkanBranding(data) {
  branding.judul = data?.judul || 'WINA'
  document.title = branding.judul // judul tab browser
  branding.logoPath = data?.logo || ''
  branding.faviconPath = data?.favicon || ''
  branding.poweredBy = data?.powered_by || 'PT PPI (Persero)'
  branding.poweredUrl = data?.powered_url || ''
  branding.idPerusahaan = data?.id_perusahaan || null
  terapkanFavicon()
}

// Sebelum login: dari domain. Sesudah login: perusahaan user (perusahaan tanpa branding sendiri ikut bawaan / domain).
export async function loadBranding() {
  const login = !!localStorage.getItem('auth_token')
  try {
    const res = await axios.post(
      apiUrl() + 'publik/branding',
      { host: window.location.hostname, id_perusahaan: login ? localStorage.getItem('id_perusahaan') || '' : '' },
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    )
    if (res.data.status === 'success') terapkanBranding(res.data.data)
  } catch {
    // server tidak terjangkau: tetap tampil dengan logo & teks bawaan
  }
}
